// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__Rb6_T","listStyleNone":"List_listStyleNone__3KObT"};